import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import {useContext} from "react";
import ListCustomersResults from "./ListCustomersResults";

export default function ListCustomersModal({show, actionLabel, embedded, action, handleCloseListCustomersModal}) {

  const [context, setContext] = useContext(AppContext);

  const actionFn = (data) => {
    action(data);
  }

  return (
    <Modal onHide={handleCloseListCustomersModal} size={'xl'} show={show}>
        <Modal.Header closeButton>
          <Modal.Title>List Customers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <ListCustomersResults
                      fromEvent={true}
                      hiddenColumns={['lastVisit', 'referral', 'familyMembers']}
                      actionLabel={actionLabel}
                      embedded={embedded}
                      action={actionFn}
                      addCustomer={true}
                    />
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
    </Modal>
  );
}